<div class="container error-page">
    <div class="row align-items-center h-100">
        <div class="col-md-12 text-center">
            <h2 class="text-danger-emphasis">Something went wrong</h2>
            <p class="text-info-emphasis">It appears that something went wrong. This URL is outdated. <br/> Please contact your bank for an updated URL to proceed.</p>
        </div>
    </div>
</div>
